import { render, staticRenderFns } from "./Submenu3.vue?vue&type=template&id=631cdd29&scoped=true&"
import script from "./Submenu3.vue?vue&type=script&lang=js&"
export * from "./Submenu3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631cdd29",
  null
  
)

export default component.exports